import { render, staticRenderFns } from "./giftExchange.vue?vue&type=template&id=ce46ce1e&scoped=true"
import script from "./giftExchange.vue?vue&type=script&lang=js"
export * from "./giftExchange.vue?vue&type=script&lang=js"
import style0 from "./giftExchange.vue?vue&type=style&index=0&id=ce46ce1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce46ce1e",
  null
  
)

export default component.exports